export const TOAST_TYPES = {
  SUCCESS: 'success',
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error',
  FETCHING: 'fetching',
  SOFT_SUCCESS: 'soft-success',
  SOFT_WARN: 'soft-warn',
  SOFT_ERROR: 'soft-error',
};
